import { SquidWidget as Squid } from "@0xsquid/widget";
import { useCallback, useEffect, useRef, useState } from "react";
import { Squid as SquidSdk } from "@0xsquid/sdk";
import { useSquidStore } from "@0xsquid/react-hooks";
import { jsx as _jsx } from "react/jsx-runtime";
const SquidWidget = _ref => {
  let {
    fromChainId,
    toChainId,
    fromTokenAddress,
    toTokenAddress
  } = _ref;
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile viewport on mount and window resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkMobile();

    // Set up resize listener
    window.addEventListener("resize", checkMobile);

    // Clean up
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // React widget configuration following official documentation
  const config = {
    integratorId: "gitcoin-50ed7b9e-5407-48c2-9b94-f443b53f6cd4",
    apiUrl: "https://apiplus.squidrouter.com",
    themeType: "dark",
    initialAssets: {
      from: {
        chainId: fromChainId,
        address: (fromTokenAddress === null || fromTokenAddress === void 0 ? void 0 : fromTokenAddress.toLowerCase()) || "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
      },
      to: {
        chainId: toChainId,
        address: (toTokenAddress === null || toTokenAddress === void 0 ? void 0 : toTokenAddress.toLowerCase()) || "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
      }
    },
    availableChains: {
      source: ["8453", "1"],
      destination: ["42161"]
    },
    slippage: 1,
    hideAnimations: true // Reduces height requirements
  };
  const sdkInitializedRef = useRef(false);
  const initializeSdk = useCallback(async () => {
    if (sdkInitializedRef.current) {
      return;
    }
    sdkInitializedRef.current = true;
    const squid = new SquidSdk({
      integratorId: config.integratorId,
      baseUrl: config.apiUrl
    });
    await squid.init();
    useSquidStore.setState(_ => ({
      squid,
      maintenanceMode: {
        active: false,
        message: undefined
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }));
  }, [config.apiUrl, config.integratorId]);
  useEffect(() => {
    initializeSdk();
  }, [initializeSdk]);
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: "100%",
      maxWidth: isMobile ? "100%" : "500px",
      height: isMobile ? "100%" : "auto",
      margin: "0 auto",
      overflow: "hidden",
      // Hide scrollbar completely
      position: "relative"
    },
    children: /*#__PURE__*/_jsx(Squid, {
      config: config,
      useExternalSquidProvider: true
    })
  });
};
export default SquidWidget;